import moment from "moment";

export const getParameterByName = (name, url = window.location.href) => {
    const formatedName = name.replace(/[[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + formatedName + '(=([^&#]*)|&|#|$)');
    const results = regex.exec(url);
    if (!results || results.length < 3) {
        return null;
    }
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

export const GuidEmpty = '00000000-0000-0000-0000-000000000000';

export const guidRegex = /^[a-z0-9]{8}-(?:[a-z0-9]{4}-){3}[a-z0-9]{12}$/;

export function applyDateFiltersFromQuery(existingFilters, filterColumns: string[]) {
    const appliedFilters = {
        $and: []
    };

    filterColumns.forEach((column) => {
        if (getParameterByName(column)) {
            const paramRegistrationDate = getParameterByName(column);
            const dateInTz = moment(paramRegistrationDate);
            const startDateInTz = dateInTz.clone().startOf("day");
            const endDateInTz = dateInTz.clone().endOf("day");
            const greaterThanDate = startDateInTz;
            const lessThanDate = endDateInTz;

            appliedFilters.$and.push({
                [column]: {
                    $greaterThanOrEqual: greaterThanDate
                }
            });

            appliedFilters.$and.push({
                [column]: {
                    $lessThanOrEqual: lessThanDate
                }
            });
        }
    });

    if (!appliedFilters.$and.length)
        return existingFilters;

    if (existingFilters) {
        if (existingFilters.$and) {
            existingFilters.$and.push(appliedFilters);
        } else {
            existingFilters = {
                $and: [appliedFilters, existingFilters]
            };
        }
    }

    return existingFilters;
}

export function cleanFieldKey(value: string): string {
    if (value) {
        return value.replace(/[^a-zA-Z0-9_-]/g, '').toLowerCase();
    }
    return value;
}